var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('draggable',_vm._b({staticClass:"folders-list draggable",attrs:{"tag":"div"},model:{value:(_vm.draggableFolders),callback:function ($$v) {_vm.draggableFolders=$$v},expression:"draggableFolders"}},'draggable',{
    handle: '.folder-drag-handle',
    animation: 200,
    group: 'folders'
  },false),_vm._l((_vm.draggableFolders),function(folder){return _c('div',{key:folder._id},[_c('folder-editable',{attrs:{"folder":folder,"link":_vm.link,"count":_vm.count(folder._id),"draggable":true}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }